import { RouteWaypoint } from 'data/model/routePlanner'

export const isSourceDestinationSet = (waypoints: (RouteWaypoint | undefined)[]): boolean =>
  waypoints !== undefined &&
  waypoints.length > 1 &&
  waypoints.filter((waypoint) => waypoint && waypoint.lat && waypoint.lng).length > 1

/**
 * Remove all empty waypoints from the routeWayPoint list
 */
export const sliceEmptyWaypoints = (routeWaypoints: RouteWaypoint[]): RouteWaypoint[] =>
  routeWaypoints.filter((waypoint) => waypoint !== undefined && waypoint.lat && waypoint.lng)

/**
 * Get the last non-empty waypoint from the routeWayPoint list
 */
export const getRouteDestination = (routeWaypoints: RouteWaypoint[]): RouteWaypoint | undefined => {
  const slicedWaypoints = sliceEmptyWaypoints(routeWaypoints)
  return slicedWaypoints.length > 1
    ? slicedWaypoints[slicedWaypoints.length - 1]
    : ({} as RouteWaypoint)
}

/**
 * Get all intermediate non-empty stops from the routeWayPoint list
 */
export const getRouteStops = (routeWaypoints: RouteWaypoint[]): RouteWaypoint[] => {
  const slicedWaypoints = sliceEmptyWaypoints(routeWaypoints)

  return slicedWaypoints.length < 3 ? [] : slicedWaypoints.slice(1).slice(0, -1)
}

export const areWaypointsSame = (waypoint1: RouteWaypoint, waypoint2: RouteWaypoint): boolean =>
  waypoint1.lat === waypoint2.lat && waypoint1.lng === waypoint2.lng
